import Alpine from 'alpinejs';

const SVG_GAP = 80;
const SVG_WIDTH = 71;
const SVG_HEIGHT = 77;
const LINE_LEFT_OFFSET = 73;
const LINE_TOP_OFFSET = 51;

Alpine.data('featuredMerch', () => ({
    activeModal: null,
    mobileModalOpen: false,

    toggleModal(index) {
        if (this.activeModal === index) {
            this.closeModal();
        } else {
            this.closeModal();
            this.activeModal = index;
            this.positionAndAnimate(index);
            this.$nextTick(() => this.positionAndAnimate(index));
            setTimeout(() => this.positionAndAnimate(index), 40);
        }
    },

    closeModal() {
        this.activeModal = null;
    },

    positionAndAnimate(index) {
        const frame = this.$el.querySelector('.featured-merch__image-frame');
        if (!frame) return;

        const hotspot = frame.querySelector(`[data-hotspot="${index}"]`);
        const modalWrapper = frame.querySelector(`[data-modal-panel="${index}"]`);
        const lineEl = this.$refs['svgLine' + index]
            || frame.querySelector(`[data-svg-line="${index}"]`);

        if (!hotspot) return;

        const frameW = frame.offsetWidth;
        const hCenterX = hotspot.offsetLeft + hotspot.offsetWidth / 2;
        const hCenterY = hotspot.offsetTop + hotspot.offsetHeight / 2;
        const modalPanel = modalWrapper ? modalWrapper.querySelector('.featured-merch__modal-panel > div') : null;
        const modalWidth = modalPanel ? modalPanel.offsetWidth : 260;

        const side = hCenterX < frameW / 2 ? 'left' : 'right';
        const hAnchorX = hCenterX;

        if (modalWrapper) {
            let modalLeft;
            if (side === 'left') {
                modalLeft = hAnchorX - SVG_GAP - modalWidth;
            } else {
                modalLeft = hAnchorX + SVG_GAP;
            }

            modalWrapper.style.position = 'absolute';
            modalWrapper.style.left = `${modalLeft}px`;
            modalWrapper.style.top = '50%';
            modalWrapper.style.transform = 'translateY(-50%)';
            modalWrapper.style.right = 'auto';

            if (lineEl) {
                const lineLeft = side === 'left'
                    ? hotspot.offsetLeft - LINE_LEFT_OFFSET
                    : hotspot.offsetLeft + hotspot.offsetWidth + 2;

                lineEl.style.left = `${lineLeft}px`;
                lineEl.style.top = `${hotspot.offsetTop - LINE_TOP_OFFSET}px`;
                lineEl.style.width = `${SVG_WIDTH}px`;
                lineEl.style.height = `${SVG_HEIGHT}px`;
                lineEl.style.transformOrigin = 'center';
                lineEl.style.transform = side === 'right' ? 'scaleX(-1)' : 'none';
            }
        }
    },

    init() {
        this.$watch('activeModal', (active) => {
            if (active !== null) {
                this.$nextTick(() => this.positionAndAnimate(active));
                setTimeout(() => this.positionAndAnimate(active), 40);
            }
        });

        const onResize = () => {
            if (this.activeModal !== null) {
                this.positionAndAnimate(this.activeModal);
            }
        };

        window.addEventListener('resize', onResize);
        this.$el.addEventListener('alpine:destroy', () => {
            window.removeEventListener('resize', onResize);
        });
    }
}));
